import styled from 'styled-components';
import { MDBDropdownItem } from 'mdbreact';
import { colors, MediaQuery } from '../../theme/style-helpers';

export const Icon = styled.img`
  transform: rotate(0);
  transition: all 0.3s;
  cursor: pointer;
  width: 16px;
  height: 20px;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  background: ${colors.WHITE};
  box-sizing: border-box;
  font-style: normal;
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 2.4rem;
  margin-bottom: 32px;

    ${MediaQuery.medium`
      flex-direction: column;
      margin: 0;
      margin-bottom: 32px;  
    `}

    ${MediaQuery.xLarge`
      flex-direction: row;
      margin-bottom: 32px;
    `}

  .search-filter {
    margin: 0;
  }

  .items-max-width {
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: 20px;

      ${MediaQuery.medium`
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: baseline;
      `}
  }

  .dropdown-companies {
    width: 100%;

    ${MediaQuery.medium`
      width: 50%;
      margin-bottom: 0px;
      margin-top: 0px;
    `}
  }
`;

export const PageTitleH1 = styled.h1`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
  margin: 0 0 16px 0;

  ${MediaQuery.small`
    font-size: 3.6rem;
    font-weight: 500;
    line-height: 47px;
  `}
`;

export const PageDescription = styled.div`
  line-height: 21px;
  font-size: 14px;

  ${MediaQuery.medium`
    font-size: 16px;
    line-height: 24px;
  `}
`;

export const ModalTitle = styled.div`
  font-size: 2.5rem;
  padding-top: 34px;
  padding-bottom: 25px;
`;

export const Close = styled.div`
  position: absolute;
  right: 32px;
  top: 32px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  &:before,
  &:after {
    position: absolute;
    left: 15px;
    content: " ";
    height: 33px;
    width: 2px;
    background-color: #333;
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

export const ModalDeleteHeader = styled.div`
  display: flex;
  justify-content: end;
`;

export const ModalBody = styled.div`
  display: grid;
  grid-gap: 64px;
  padding: 0 28px;
  font-size: 1.5rem;
  text-align: center;
`;

export const ButtonDiv = styled.div`
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 0px;
`;

export const FilterIcon = styled.div`
  font-size: 16px;
  line-height: 20px;
  margin-top: -28px;
  cursor: pointer;
`;

export const PageTitle = styled.div`
  font-size: 24px;
  line-height: 29px;
  margin-bottom: 16px;
`;

export const CategoryTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: 0.04em;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;

  &.space-between{
    justify-content: space-between;
  }
`;

export const SuccessDeleteMessage = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: ${colors.LAND_GREEN};
`;

export const ActionsContainer = styled.div`
  display: flex;

  ${MediaQuery.medium`
    padding-top: 15px;
  `}

  ${MediaQuery.xLarge`
    padding-left: 80px;
  `}
`;

export const FiltersAndTableContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 32px;
  margin-bottom: 32px;
`;

export const TableContainer = styled.div`
  font-size: 14px;
  margin: 42px 0 56px;

  table {
  thead {
    tr {
      background-color: #F2F2F2;
      cursor: pointer;
    }

    th {
      border-bottom: 0;
    }

    th:first-child {
      padding: 8px;
    }

    p {
      font-weight: 500;
    }
  }
  tbody {
  
  p:last-child {
    padding: 16px;
  }
  tr:nth-child(even) {
    background-color: #ffffff !important;
  }
  tr {
    border-bottom: 1px solid rgb(217, 217, 214);
  }
  td:first-child {
    padding: 16px !important;
  }
    li {
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    &.active {
      font-weight: 100;
      width: 100px;
    }
  }
}
}
.dropdown {
    .btn{
      padding: 0 !important;
    }
    .dropdown-menu {
        padding: 24px;
        background-color: rgb(249, 249, 249) !important;
        border: 1px solid rgba(0, 0, 0, .15) !important;
    }

    .button-dropdown {
      display: flex;
      justify-content: center;
      width: 25px;
      }
    }

    .dropdown-item {
      font-weight: 500;
      margin: 0 !important;
      margin-bottom: 20px !important;

      &:last-child {
        margin-bottom: 0px !important;
      }
    }
}
`;

export const PaginationContainer = styled.div`
    width: 100%;
    margin: 0;
    
    ul {
        display: flex;
        flex-wrap: wrap;
        gap: 32px;
        justify-content: center;
        padding: 0;
        margin: 0;
        list-style: none;

        li {
            padding: 1rem 1.5rem;
            font-size: 16px;
            font-weight: 500;
   
            &.active {
                font-size: 16px !important;
                font-weight: 700 !important;
                border-bottom: 2px solid rgb(255, 95, 20);
                text-decoration: none !important;
            }
        }
    }
`;

export const DropdownItem = styled(MDBDropdownItem)`
  display: flex !important;
  align-items: center !important;
  padding: 0px !important;
  cursor: pointer;

  p {
    padding: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  &:enabled {
    color: ${colors.BLACK} !important;
  }

  &:disabled {
    color: ${colors.DARK_GREY} !important;
  }

  &:hover {
    p {
      color: ${colors.BRAND_ORANGE} !important;
      padding: 0 !important;
    }
  }
`;

export const BoxContainer = styled.div`
  padding: 20px 8px 20px 17px;
  background-color: ${({ bgColor }) => (bgColor || colors.WHITE)};
  max-width: ${({ maxWidth }) => maxWidth && maxWidth};
  max-height: ${({ maxHeight }) => (maxHeight || 'unset')};

  >div {
    padding-left: 3px;
    padding-top: 1px;
    display: grid;
    grid-template-columns: 20px;
  }

  .rw-list {
    gap: 16px;
  }
`;

export const BoxInfo = styled.div`
  display: grid;
  grid-gap: 16px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.COOL_GREY};
    border-radius: 100px;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${colors.DARK_GREY};
  }
`;

export const CategoryContainer = styled.div`
  display: grid;
  grid-gap: 12px;
`;

export const SubTitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  max-width: 872px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
  margin: 0;
`;

export const TitlesContainer = styled.div`
  display: grid;
  grid-gap: 8px;
`;

export const LeftSideBarBodyContainer = styled.div`
  display: grid;
  grid-gap: 32px;
  max-width: 347px;
`;

export const ManageContactsForm = styled.div`
  .contacts-column {
    margin-top: -32px;
    margin-bottom: 16px;
  }
  .delete-contacts-modal{
    //padding: 0;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  display: grid;
  grid-auto-flow: row;
  row-gap: 8px;
  grid-auto-rows: max-content;
`;

export const SearchLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  margin: 0;
`;

export const FilterCategoryTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
`;

export const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;

  * {
    pointer-events: none;
  }

  object {
    width: 20px;
  };
`;
